/**
 * Metni belirli bir uzunluğa kısaltır
 *
 * @param {String} text - Kısaltılacak metin
 * @param {Number} maxLength - Maksimum uzunluk
 * @returns {String} Kısaltılmış metin
 */
export const truncateText = (text, maxLength) => {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

/**
 * Metnin belirtilen maksimum uzunluğa göre kısaltılıp kısaltılmadığını kontrol eder
 *
 * @param {String} text - Kontrol edilecek metin
 * @param {Number} maxLength - Maksimum uzunluk
 * @returns {Boolean} Eğer metin kısaltılmışsa true, değilse false döner
 */
export const isTextTruncated = (text, maxLength) => {
  if (!text) return false
  return text.length > maxLength
}

/**
 * Dosya boyutunu formatlı olarak döndürür
 *
 * @param {Number} size - Bayt cinsinden boyut
 * @returns {String} Formatlanmış boyut (örn. "1.5 MB")
 */
export const formatFileSize = (size) => {
  if (size < 1024) return size + ' B'
  else if (size < 1048576) return (size / 1024).toFixed(1) + ' KB'
  else return (size / 1048576).toFixed(1) + ' MB'
}

/**
 * Kategori listesini virgülle ayrılmış string'e dönüştürür
 *
 * @param {Array} categories - Kategori nesneleri dizisi
 * @returns {String} Virgülle ayrılmış kategori isimleri
 */
export const getCategoryList = (categories) => {
  if (!categories || !Array.isArray(categories)) return ''
  return categories.map(cat => cat.name).join(', ')
}